import React from 'react';
import * as PropTypes from 'prop-types';

import { Wrapper } from './elements';

function Wra12A(props) {
  return (
    <Wrapper
      className={props.className}
      onClick={props.onClick}
      style={props.style}
    >
      {props.children}
    </Wrapper>
  );
}

Wra12A.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default Wra12A;
